<template>
  <div>
    <!--订单分类-->
    <div class="bg-white load-area" ref="scrollWrap">
        <ul class="order-tab mb-3">
            <li v-for="tab in tabArr()" :key="tab.status" :class="{'tab-active':tab.status==formData.status}" @click="changeTab(tab.status)">
                <i :class="tab.icon " class="iconfont"></i>
                {{ tab.title }}
                <span v-if="infoNum[tab.value]>0" class="order-num" :class="tab.color">{{infoNum[tab.value]>99?'99+':infoNum[tab.value]}}</span>
            </li>
            <li class="orderRecovery" :class="{'tab-active':66==formData.status}" @click="changeTab('66')" v-if="!isGroup&&!isAdmin">
                <i class="el-icon-delete"></i>
                订单回收站
            </li>
        </ul>
        <!--订单搜索-->
        <SearchCon @getSearchCon="getSearchCon" ref="searchCon" :user_list="user_list" @isExpand="isExpand"></SearchCon>
        <!--订单列表-->
        <template v-if="total>0&&!loading">
            <OrderList :orderList="orderList" class="mt-3" :status="formData.status*1" @getOrderFlag="getOrderFlag" @openFinance="openFinance" @uploadInvoice="uploadInvoice" @deleteOrder="deleteOrder" @restoreOrder="restoreOrder" ref="orderList"></OrderList>
            <!--分页--> 
            <div class="el-pagination">
                <el-pagination background layout="total,prev, pager, next" 
                    :page-size="10"
                    :total="total" :current-page="Number(formData.page)"
                    @current-change="$GFUN.pageChange"/>
            </div>
        </template>
        <!--没有搜索到相关结果-->
        <div class="itemcard" v-if="orderList.length==0&&!loading">
            <div class="no-search-result">
            <img src="/images/order/icon_22.png"/>
            <div class="no-search-text">
                <p class="one">抱歉，没有搜索到相关订单。</p>
                <p class="two">请更改选项后重试</p>
                <el-button type="primary" @click="clearSearch" v-if="Object.keys(this.searchCon).length > 0" class="no-button">清除选项</el-button>
            </div>
            </div>
        </div>
        <!--骨架屏-->
        <div class="loading" v-if="loading">
            <Spinner></Spinner>
        </div>
        <!--删除提示-->
        <DeletePrompt ref="deletePrompt" :deletePrompt="deletePrompt" :deletePromptIndex="deletePromptIndex" @deleteOrderConfirm="deleteOrderConfirm" @close="deletePrompt=false"></DeletePrompt>
        <!--提交财务弹窗-->
        <el-dialog :title="storeInfo.level==3?'提交打款':'提交财务'" :visible.sync="finance" width="340px" class="paymentist" :close-on-click-modal="false" top="16%">
            <commission v-if="finance" @finance="finance=!finance" :oid="financeoid" :price_pay="financeprice" @submitFinance="submitFinance"></commission>
        </el-dialog>
    </div>  
  </div>
</template>

<script>
 import SearchCon from '../Components/SearchCon'                    //订单搜索组件
 import OrderList from '../Components/List'                         //订单列表组件
 import Flag from '../Components/Flag'                              //订单标记组件
 import Spinner from '../Components/Spinner'                        //骨架屏组件
 import DeletePrompt from '../Components/DeletePrompt'              //删除提示组件
 import commission from '../../Admin/FinancialManage/Subassembly/commission.vue'                      //提交财务组件
 import OrderuploadInvoice from '@/views/Order/OrderDetail/HotelOrder/Components/OrderuploadInvoice'; //上传发票弹窗
 import { mapGetters,mapState,mapActions } from 'vuex'
 import { debounce } from "lodash";
export default {
  name: '',
  components: {
    SearchCon,
    OrderList,
    Flag,
    commission,
    OrderuploadInvoice,
    Spinner,
    DeletePrompt,
  },
  props: {},
  data() {
    return {
        formData:{
            page:1,
            type:2,
            num:10,
            status:'',
        },
        //搜索条件
        searchCon:{},
        //总条数
        total:0,
        //当前列表
        orderList:[],
        orderType:[{
            title:'全部订单',
        }],
        loading:true, //加载中
        //标记数量
        infoNum:{
            status_today:0,
            status_7:0,
            status_8:0,
            status_6:0,
        },
        //订单标记弹窗
        showFlagPanel:false,
        flagtiem:{},
        flagtype:'',
        //提交财务弹窗
        finance:false,
        financeprice:0,   
        financeoid:'',                                //提交财务订单号
        //上传发票弹窗
        uploadInvoiceShow:false,                     //上传发票弹窗
        editMode:false,                              //是否编辑发票
        existImgs:'',                                //已存在发票
        isClick:false,                               //禁止连续点击
        invoiceType:'',                              //发票点击的身份值
        orderDetail:{},                             //订单详情
        //删除提示组件
        deletePrompt:false,           
        //删除提示词显示
        deletePromptIndex:1,
        //当前删除值
        deleteRow:{},
        //旗下人员                 
        user_list:[],
    };
  },
  computed: {
     ...mapState(['newMessageInform']),
     ...mapGetters(['storeInfo', 'userInfo', 'isAdmin', 'isGroup']),
  },
  watch: {
        newMessageInform(newVal) {
            //收到通知刷新当前页面
            if (newVal && this.$GFUN.isInArray([30,39,40,42,43,44,45,46,47],newVal.type)){
                this.initial();
            }
        },
    '$route.query':{
        handler(toVal,fromVal){
            this.formData.page=toVal.page||1
            this.formData.status=toVal.status||''
            this.initial();
        },
        immediate:true
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
    ...mapActions(['POST_OrderHotelList','adminSubmitFinance','getUserIndexData','cancellationDelOrderHotel','POST_RestoreOrder']),
        //切换搜索分类
        tabArr() {  
            let tabArr = [
                    {title: '全部', status: '' ,icon:'icon-qinggoudanguanli'},
                    {title: '今日住', status: 'today',value:'status_today',icon:'icon-quanxianziyuanguanli',color:'green'},
                    {title: '已入住', status: '7',value:'status_7',icon:'icon-qinggoudanguanli',color:'green'},
                    {title: '已离店', status: '8',value:'status_8',icon:'icon-shenpibohui'},
                    {title: '待入住', status: '6',value:'status_6',icon:'icon-daiqueren',color:'Orange'},
                    {title: '完成', status: '9',icon:'icon-shenpitongguo'},
                    {title: '取消',status: '99',icon:'icon-zhengdanweihuyichang'},
            ]
            //集团去掉第一个和最后一个
            if(this.isGroup){
                tabArr.splice(0,1)
                tabArr.splice(-1,1)
            }
            return tabArr
        },
        //初始化
        initial(){
            this.formData={...this.formData,...this.searchCon}
            this.list();
        },
        //获取订单列表
        list: debounce(function(){
            this.loading = true;
            this.POST_OrderHotelList({
                data:this.$_Object.removeEmptyProps(this.formData),
                successFun:(res)=>{
                    const scrollRef = this.$refs.elScroll;
                    console.log(this.$refs.elScroll);
                    console.log(scrollRef);
                    // 取 $refs.wrap
                    if (scrollRef ) {
                        scrollRef.$refs.wrap.scrollTop = 0
                    }
                    this.infoNum = res.info;
                    this.total = res.count;
                    this.orderList = res.list;
                    if(this.isGroup){
                        const newArr = res.user_list.map(item => ({
                            name: item.truename,
                            id: item.uid
                        }))
                        this.user_list = newArr;
                    }
                    this.loading = false;   
                }
            })
        },500),
        //切换搜索分类
        changeTab(status){
            this.formData.page=1;   
            this.formData.status=status;
            //保存到路由
            this.$router.push({
                name: this.$route.query.name,
                query: {status:status, page: 1}
            })
            this.searchCon={};
        },
        /*根据条件搜索订单*/
        getSearchCon(con) {
            this.searchCon = con||{};
            if (this.formData.page == 1) {this.initial()}
            else {
                this.$router.push({
                    name: this.$route.query.name,
                    query: {...this.formData, page: 1}
                })
            };
        },
        //开启订单标记
        getOrderFlag(item,type){
            this.showFlagPanel=true;
            this.flagtiem=item;
            this.flagtype=type;
        },
        /**
         * 开启提交财务弹窗
         */
        openFinance(res){
            let price=0,price_pay=res.price_pay/100;
            if(res.price<price_pay){
                price=res.price
            }else{
                price=price_pay
            }
            this.financeoid=res.oid;
            this.financeprice=price;
            this.finance=true;
        },
        /**
         * 管理员提交财务
         */
        submitFinance(ruleForm){
            this.finance=!this.finance
            this.adminSubmitFinance({
                type:this.isAdmin?3:4,
                data:ruleForm,
                successFun: () => {
                    this.list();
                    this.getUserIndexData();
                    this._alert(this.storeInfo.level==3?'已提交打款申请,请等待企业通过':'已提交财务，可在待打款列表中查看');
                }
            });
        },
        //开始上传发票
        uploadInvoice(e){
            let editMode=this.isAdmin?true:e.type==this.storeInfo.type;
            if(!this.isClick){
                console.log(editMode);
                this.invoiceType=e.type;
                this.editMode=editMode;
                if(this.existImgs===e.receipt||e.receipt==''){
                this.uploadInvoiceShow=true ;
                return;
                }
                this.orderDetail=e.item;
                this.isClick=true;
                this.existImgs=e.receipt;
            } 
        },
        //删除订单
        deleteOrder(item,scope){
            this.deletePrompt=true;
            this.deleteRow=item;
            this.deletePromptIndex=scope;

        },
        //删除订单确认
        deleteOrderConfirm(){
            this.cancellationDelOrderHotel({
                oid:this.deleteRow.oid,
                orderStatus:this.formData.status,
                successFun: () => {
                    this.deletePromptIndex= this.deletePromptIndex==3?5:2;
                    this.list();
                }
            });
        },
        //还原订单
        restoreOrder(item){ 
            this.POST_RestoreOrder({
                oid:item.oid,
                successFun: () => {
                    this.deletePrompt=true;
                    this.deletePromptIndex=4;
                    this.list();
                }
            });
        }
        ,
        //清除搜索条件
        clearSearch(){
            this.$refs.searchCon.resetSearch();
        },
        //搜索模式
        isExpand(res){
            //调用子级方法
            this.$refs.orderList.searchExpand(res);
            console.log(res);
        }
        //搜索
  }
};
</script>

<style lang="scss" scoped>
    .load-area{
        background-color:inherit !important;
        padding:0 !important;
        min-width: 1200px;
    }
    .order-tab{
        display: flex;
        justify-content: left;
        width: 100%;    
        box-sizing: border-box;
        li{
            margin-right: 20px;
            padding: 6px 24px;
            background-color: #fff;
            border-radius: 5px;
            display: flex;
            align-items: center;
            color: #666;
            cursor: pointer;
            font-weight: bold;
            i{
                margin-right: 5px;
                font-size: 18px;
                margin-top: 2px;
                font-weight: normal;
            }
            .order-num{
                margin-left: 10px;
                background-color: #eee;
                width: 26px;
                height: 26px;
                line-height: 26px;
                text-align: center;
                border-radius: 50%;
                margin-top: 1px;
                font-weight: bold;
                font-size: 12px;
                color: #666 !important;
            }
        }
        .tab-active{
            background-color: var(--smtc-color-primary);
            color: #fff;
        }
    }
    .el-pagination{
        background-color: #fff;
        margin-top:14px;
        padding-bottom:10px;
    }
    .no-search-result{
        width: 100%;
        background-color: #fff;
        box-shadow: 0px 0px 7px #eee;
        border-radius: 16px;
        display: flex;
        justify-content: center;
        padding: 52px 0;
        margin-top: 20px;
        img{
        width: 120px;
        }  
    }
    .no-search-text{
        margin-left: 14px;
        text-align: left;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .one{
        font-weight: bold;
        font-size: 16px;
        }
        .two{
        color: #666;
        margin: 6px 0;
        }
    }
    .img-info{
        display: flex;
        img{
        margin-top: 4px;
        margin-right: 8px;
        }
    }
    .no-button{
        width: 120px;
        padding: 8px 0;
    }
    .orderRecovery{
        margin-left: auto;
        margin-right: 0 !important;
        i{
            font-size: 16px !important;
        }  
    }
</style>
